import { Box, Svg, Text } from '@hopskipdrive/react-components';

import { Button } from '../../../shared/components/Button';
import { CopyToClipboard } from '../../../shared/components/CopyToClipboard';
import { colorTokens } from '../../../shared/components/variables';
import { useIsMobileOrTablet } from '../../../shared/utils/helpers/util';
import { DriverDetails } from '../../types/driver';

interface IDriverHeader {
  driverDetails: DriverDetails;
  showRemoveDriverButton?: boolean | false;
  setRemoveDriverModalOpen?: (value: boolean) => void;
  hideSlug?: boolean | true;
}

export const DriverHeader = ({
  driverDetails,
  showRemoveDriverButton,
  setRemoveDriverModalOpen,
  hideSlug,
}: IDriverHeader) => {
  const isMobileOrTablet = useIsMobileOrTablet();

  return (
    <>
      <Box
        display="flex"
        alignItems={isMobileOrTablet ? 'flex-start' : 'center'}
        gap="12px"
        flexDirection={isMobileOrTablet ? 'column' : 'row'}
      >
        <Box display="flex" alignItems="center" gap="12px">
          <Svg
            icon="directions-car-filled"
            style={{
              display: 'block',
              height: '24px',
              width: '24px',
              alignSelf: 'center',
              color: colorTokens.primary.main,
            }}
          />
          <Text variant="h6" style={{ color: colorTokens.primary.main }}>
            Driver
          </Text>
        </Box>
        {!hideSlug && (
          <Box>
            <CopyToClipboard
              toastMessage="Slug Copied"
              text={driverDetails?.slug || ''}
              variant="h6"
              color={colorTokens.text.secondary}
            />
          </Box>
        )}
      </Box>
      <Box alignSelf={isMobileOrTablet ? 'flex-start' : 'auto'}>
        {showRemoveDriverButton && setRemoveDriverModalOpen && (
          <Button
            color="warning"
            startIcon={<Svg icon="cross" />}
            style={{
              border: `1px solid ${colorTokens.error.outlineBorder}`,
              color: `${colorTokens.error.dark}`,
            }}
            onClick={() => setRemoveDriverModalOpen(true)}
          >
            Remove Driver
          </Button>
        )}
      </Box>
    </>
  );
};
